var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"open-private-dm"},[_c('vue-element-loading',{attrs:{"active":_vm.loading,"is-full-screen":""}}),(_vm.error)?_c('p',{staticClass:"open-private-dm__error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }